import React, {useEffect, useMemo, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import  {InBasketButton} from '../../../components/InBasketButton';
import CourseTag from './CourseCardTag';
import CourseList from './CourseCardList';
import Tabs from './Tabs';
import './CourseCard.css';
import {CustomDropdown} from "../../../components/CustomSelect";
import {ImageWithFallback} from "../../../components/ImageWithFallback";
import CourseCardPrice from "./CourseCardPrice";
import coursesStore from "../../../store/CourseStore";
import {observer} from "mobx-react-lite";
import {courseFallBack} from "../../../helpers/shared";

const classLocalization = {
    9:  'ОГЭ',
    11: 'ЕГЭ'
}

const ALL_SUBJECTS = 'все предметы'
const ALL_COURSES = 'все курсы'
const ALL_CLASS_COURSE = 'все экзамены'

 const CourseCard= observer(()=> {
    const navigate = useNavigate();
    const data = coursesStore.data

    const [selectedSubject, setSelectedSubject] = useState(ALL_SUBJECTS);

    const [currentCourse, setCurrentCourse] = useState(null)
    const [currentClassCourse, setCurrentClassCourse] = useState(null)

    const {courseOptions, classOptions, subjectOptions} = useMemo(() => {

        if(data === null) return []

        const uniqueClassOptions = [{name: ALL_CLASS_COURSE},
            ...new Map(
                data
                    .filter(({class_course}) => classLocalization[class_course])
                    .map(({class_course}) => [
                        class_course,
                        { class_course: class_course, name: classLocalization[class_course] },
                    ])
            ).values(),
        ];

        const uniqueSubjects = [
            ALL_SUBJECTS, // Добавляем 'Все предметы' в начало
            ...new Set(data.map(({subject}) => subject.toLowerCase())?.filter(subject => subject !== ''))
        ];


        return {courseOptions :[{name: ALL_COURSES},...data.map(({title, id}) => ({name: title, id}))], classOptions: uniqueClassOptions, subjectOptions: uniqueSubjects}}, [data])

const filteredCourses = useMemo(() => {
    if(data === null) return []
        let filteredData = data

    if(currentClassCourse !== null && currentClassCourse?.name !== ALL_CLASS_COURSE) {
        filteredData = filteredData.filter(({class_course}) => class_course === currentClassCourse.class_course)
    }

    if(currentCourse !== null && currentCourse?.name !== ALL_COURSES) {
        filteredData=  filteredData.filter(({id}) => id === currentCourse.id)
    }

    if(selectedSubject !== ALL_SUBJECTS) {
        filteredData= filteredData.filter(({subject}) => subject.toLowerCase() === selectedSubject.toLowerCase())
    }

    return filteredData
},[currentClassCourse, currentCourse, selectedSubject, data])

    useEffect(() => {
        coursesStore.fetchAllCoursesData();
    }, [ ]);


    const handleCourseClick = (courseId) => {
        navigate(`/courses-detail/${courseId}`);
    };


     const handleInBasketClick = (e, id) => {
         e.stopPropagation();
         navigate(`/courses-options/${id}`);
     };

    if(coursesStore.isLoading) {
        return <div>Идет загрузка...</div>
    }

    return (
        <div className="course-card">
            <div class="flex flex-col gap-[20px] mb-[34px]">
            <div class="flex gap-[15px]">
                <CustomDropdown
                    options={classOptions}
                    selectedOption={currentClassCourse}
                    placeholder='все экзамены'
                    onOptionSelect={(class_course) => setCurrentClassCourse(class_course)}
                />

                <CustomDropdown
                    options={courseOptions}
                    selectedOption={currentCourse}
                    placeholder={ALL_COURSES}
                    onOptionSelect={(course) => setCurrentCourse(course)}
                />
            </div>

                {subjectOptions?.length > 0 &&
                    <Tabs
                        tabs={subjectOptions}
                        selectedTab={selectedSubject}
                        onSelectTab={setSelectedSubject}
                    />}
            </div>


            <div class="flex flex-wrap gap-[25px] break-p-800:justify-start justify-center">
                {filteredCourses?.length > 0 ? (
                    filteredCourses?.map(course => (
                        <div
                            key={course.id}
                            class="w-full sm:w-[435px] rounded-[20px] dark:bg-dark-bg bg-element-bg  cursor-pointer hover:shadow-md active:opacity-80"
                        >
                            <div class='flex flex-col p-[20px] gap-[20px]'  onClick={() => handleCourseClick(course.id)}>
                                <div className="overflow-hidden rounded-[20px] ">
                                    <ImageWithFallback
                                        className="rounded-[20px] w-full h-sm-[237px] object-cover"
                                        src={`${course.image_url}`} alt={course.title}
                                        fallbackSrc={courseFallBack}
                                    />
                                </div>

                                {/* {course.teacher_first_name && course.teacher_last_name &&
                                <CourseList
                                    teacher={`${course.teacher_first_name} ${course.teacher_last_name}` }
                                />} */}

                            </div>

                            <div class='mt-sm-[25px] mb-2 mb-sm-8 px-4 px-sm-12 text-center'>
                                <h2 class='w-full text-[24px] font-semibold dark:text-white text-sub-title break-words'>{course.title}</h2>
                            </div>

                            <div class='mb-4 mb-sm-[47px]'>
                                <CourseTag />
                            </div>

                            {course.price &&
                                <div className='flex justify-center'>
                                <CourseCardPrice price={course.price}/>
                            </div>}


                            <div class='flex justify-center mt-[22px] mb-[30px]'>
                                <InBasketButton
                                    onClick={(e) =>handleInBasketClick(e, course.id)}
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <p>Курсы не найдены...</p>
                )}
            </div>
        </div>
    );
})

export default CourseCard